import {TemplateRef} from "@angular/core";

export class ToggleSelectElModel {
  name: string;
  icon: TemplateRef<any> | null;
  activeIcon: TemplateRef<any> | null;

  constructor(name: string, icon: TemplateRef<any> | null, activeIcon: TemplateRef<any> | null) {
    this.name = name;
    this.icon = icon;
    this.activeIcon = activeIcon;
  }

  public static create(name: string, icon: TemplateRef<any> | null, activeIcon: TemplateRef<any> | null): ToggleSelectElModel {
    return new ToggleSelectElModel(name, icon, activeIcon);
  }
}
